/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'wallet': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 204.8c0-56.32 46.08-102.4 102.4-102.4h768a51.2 51.2 0 0151.2 51.2v51.2H102.4V256h870.4a51.2 51.2 0 0151.2 51.2v512a102.4 102.4 0 01-102.4 102.4H102.4A102.4 102.4 0 010 819.2V204.8zm844.8 460.8a76.8 76.8 0 100-153.6 76.8 76.8 0 000 153.6z"/>'
  }
})
